import { throttle } from "lodash-es";

import { rollbarAndLogWarning } from "./logger";

const AUDIO_THROTTLE = 8000;

const handRaiseAudio = new Audio("/sounds/handraise.mp3");
const breakoutAudio = new Audio("/sounds/breakout_chime.mp3");
const tickingAudio = new Audio("/sounds/ticking.mp3");
const timerEndAudio = new Audio("/sounds/timer_notification.mp3");
const testAudio = new Audio("/sounds/test_sound.mp3");

// Try to start playback, but don’t assume it will succeed.
const maybePlayAudio = async (audio: HTMLAudioElement) => {
  // On mobile browsers (e.g., iOS Safari) the browser may block autoplay
  // unless audio is a result of user interaction or other audio is already playing.
  // In those cases `audio.play()` returns a Promise that rejects.
  // We will not retry as those are time sensitive sounds and unblocking will often depend on the user's interaction.
  try {
    await audio.play();
  } catch (error) {
    // We only send to rollbar warnings for errors that are not related to autoplay blocking.
    if (error?.name === "NotAllowedError") {
      console.info("[maybePlayAudio] Error playing audio", error);
    } else {
      rollbarAndLogWarning("[maybePlayAudio] Error playing audio", error);
    }
  }
};

export const playHandRaiseAudio = throttle(
  () => {
    maybePlayAudio(handRaiseAudio);
  },
  AUDIO_THROTTLE,
  { trailing: false },
);

export const playBreakoutAudio = () => {
  maybePlayAudio(breakoutAudio);
};

export const playTickingAudio = () => {
  maybePlayAudio(tickingAudio);
};

export const playTimerEndAudio = () => {
  maybePlayAudio(timerEndAudio);
};

export const playTestAudio = (audioStoppedCallback: () => void) => {
  // We are using maybePlayAudio here but, since this is started by the user, it is very unlikely to fail.
  maybePlayAudio(testAudio);
  testAudio.onended = audioStoppedCallback;
  testAudio.onerror = audioStoppedCallback;
};

export const stopTickingAudio = () => {
  tickingAudio.pause();
  tickingAudio.currentTime = 0;
};
